<script>
  import ChipBase from "./ChipBase.svelte";

  export let title
</script>

<ChipBase color="#019e95">
  {title}
</ChipBase>
